import { cEl } from '../../../../util';
import pageLeftArrow from '../../../../assets/images/page-left-arrow.svg';
import pageRightArrow from '../../../../assets/images/page-right-arrow.svg';
import { navigateTo } from '../../../AppHeader/Link';
import { PATH_ADMIN_SUBMISSION_DETAIL, PATH_ADMIN_SUBMISSIONS, PATH_VARIABLE_SUBMISSION_NUM } from '../../../path';
import { getSubmissionsQueryParam } from './index';

export const PAGE_SIZE = 17;
export const PAGE_LIST_SIZE = 5;

export const ORDER_BY_ASC = 'ASC';
export const ORDER_BY_DESC = 'DESC';

export const CHECK_OPTION_IN_PAGE = 'inPage';
export const CHECK_OPTION_ALL = 'all';

export const persistentState = {
    [CHECK_OPTION_ALL]: false,
    excludedSubmissionNums: [],
};

export const initializePersistentState = () => {
    persistentState[CHECK_OPTION_ALL] = false;
    persistentState.excludedSubmissionNums = [];
};

const Checkbox = ({ name, value }) => {
    const checkboxContainer = cEl('label');
    checkboxContainer.classList.add('checkbox');

    const input = cEl('input');
    input.type = 'checkbox';
    input.name = name;
    input.value = value;

    const box = cEl('span');
    box.classList.add('box');

    checkboxContainer.append(input, box);

    return checkboxContainer;
};

const CheckboxHeader = () => {
    const container = cEl('div');
    container.classList.add('checkbox-container');
    const checkbox = Checkbox({ name: 'allSubmissionNum' });
    if (persistentState[CHECK_OPTION_ALL]) {
        const inputCheck = checkbox.querySelector('input');
        inputCheck.value = CHECK_OPTION_ALL;
        inputCheck.checked = true;
        document.querySelector('.action-container').classList.add('active');
    }
    checkbox.addEventListener('click', e => {
        e.preventDefault();
        const inputCheck = checkbox.querySelector('input');
        dropdownContainer.style.top = e.clientY + 'px';
        dropdownContainer.style.left = e.clientX + 'px';
        if (inputCheck.checked) {
            inputCheck.checked = false;
            handleChangeCheckbox(false);
            initializePersistentState();
        } else {
            if (dropdownContainer.classList.contains('opened')) {
                dropdownContainer.classList.remove('opened');
            } else {
                dropdownContainer.classList.add('opened');
            }
        }
    });

    const handleChangeCheckbox = checked => {
        const actionBox = document.querySelector('.action-container');
        if (checked) {
            document.querySelectorAll('.submissions-container [name="submissionNum"]').forEach(checkbox => {
                checkbox.checked = true;
            });
            actionBox.classList.add('active');
        } else {
            document.querySelectorAll('.submissions-container [name="submissionNum"]').forEach(checkbox => {
                checkbox.checked = false;
            });
            actionBox.classList.remove('active');
        }
    };

    container.append(checkbox);

    if (document.body.querySelector('.dropdown-container')) {
        return container;
    }

    const dropdownContainer = cEl('div');
    dropdownContainer.id = 'checkAll';
    dropdownContainer.classList.add('dropdown-container');
    const inPage = cEl('div');
    inPage.classList.add('dropdown-item');
    inPage.innerHTML = '이 페이지의 문의 선택';
    inPage.addEventListener('click', () => {
        dropdownContainer.classList.remove('opened');
        const inputCheck = checkbox.querySelector('input');
        inputCheck.value = CHECK_OPTION_IN_PAGE;
        inputCheck.checked = true;
        handleChangeCheckbox(true);
    });
    const overPage = cEl('div');
    overPage.classList.add('dropdown-item');
    overPage.innerHTML = '모든 문의 선택';
    overPage.addEventListener('click', () => {
        dropdownContainer.classList.remove('opened');
        const inputCheck = checkbox.querySelector('input');
        inputCheck.value = CHECK_OPTION_ALL;
        inputCheck.checked = true;
        handleChangeCheckbox(true);
        initializePersistentState();
        persistentState[CHECK_OPTION_ALL] = true;
    });

    dropdownContainer.append(inPage, overPage);
    document.addEventListener('click', e => {
        if (!checkbox.contains(e.target)) {
            dropdownContainer.classList.remove('opened');
        }
    });

    document.body.append(dropdownContainer);

    return container;
};

const columns = [
    {
        width: 30,
        accessor: 'submissionNum',
        Header: CheckboxHeader,
        Cell: (data, row, meta) => {
            if (data) {
                const container = cEl('div');
                container.classList.add('checkbox-container');
                container.addEventListener('click', e => {
                    e.stopPropagation();
                });
                const checkbox = Checkbox({ name: 'submissionNum', value: data });
                if (persistentState[CHECK_OPTION_ALL] && !persistentState.excludedSubmissionNums.includes(data)) {
                    checkbox.querySelector('input').checked = true;
                }
                checkbox.addEventListener('change', e => {
                    const allCheckbox = document.querySelector('.submissions-container input[name="allSubmissionNum"]');
                    const actionBox = document.querySelector('.action-container');
                    if (e.target.checked) {
                        actionBox.classList.add('active');
                        persistentState.excludedSubmissionNums = persistentState.excludedSubmissionNums.filter(
                            submissionNum => data !== submissionNum,
                        );
                        if (
                            !persistentState[CHECK_OPTION_ALL] &&
                            document.querySelectorAll('.submissions-container [name="submissionNum"]:checked')
                                .length ===
                                document.querySelectorAll('.submissions-container [name="submissionNum"]').length
                        ) {
                            allCheckbox.value = CHECK_OPTION_IN_PAGE;
                            allCheckbox.checked = true;
                        }
                    } else {
                        persistentState.excludedSubmissionNums.push(data);
                        if (persistentState[CHECK_OPTION_ALL]) {
                            if (meta.totalCount === persistentState.excludedSubmissionNums.length) {
                                persistentState[CHECK_OPTION_ALL] = false;
                                allCheckbox.checked = false;
                                actionBox.classList.remove('active');
                            }
                        } else if (
                            !document.querySelectorAll('.submissions-container [name="submissionNum"]:checked').length
                        ) {
                            actionBox.classList.remove('active');
                        }
                    }
                });
                container.append(checkbox);
                return container;
            }
        },
    },
    {
        width: 35,
        accessor: 'submissionNum',
        Header: '#',
        sortable: true,
    },
    { width: 65, accessor: 'name', Header: '이름' },
    {
        width: 140,
        accessor: 'regDate',
        Header: '테스트 날짜',
        sortable: true,
        Cell: data => {
            if (data) {
                const dateStr = formatTimestamp(data);
                const tableCell = cEl('span');
                tableCell.classList.add('table-cell');
                tableCell.innerHTML = dateStr;
                tableCell.title = dateStr;
                return tableCell;
            }
        },
    },
    { width: 140, accessor: 'email', Header: '이메일 주소' },
    { width: 110, accessor: 'phone', Header: '휴대폰 번호' },
    { width: 120, accessor: 'affiliation', Header: '소속 기관' },
    { width: 200, accessor: 'message', Header: '문의 내용' },
    {
        width: 80,
        accessor: 'questionnaireCompleted',
        Header: '테스트 진행',
        sortable: true,
        Cell: data => {
            if (typeof data === 'boolean') {
                const tableCell = cEl('span');
                tableCell.classList.add('table-cell', 'text-center', data ? 'color-brand' : 'color-danger');
                tableCell.innerHTML = data ? '진행' : '미진행';
                return tableCell;
            }
        },
    },
    {
        width: 55,
        accessor: 'readinessScore',
        Header: '준비 정도',
        classNames: ['text-center'],
    },
    {
        width: 55,
        accessor: 'guideRobotScore',
        Header: '안내 로봇',
        classNames: ['text-center'],
    },
    {
        width: 55,
        accessor: 'medDeliveryRobotScore',
        Header: '약제 로봇',
        classNames: ['text-center'],
    },
    {
        width: 55,
        accessor: 'specimenDeliveryRobotScore',
        Header: '검체 로봇',
        classNames: ['text-center'],
    },
    {
        width: 55,
        accessor: 'docDeliveryRobotScore',
        Header: '문서 로봇',
        classNames: ['text-center'],
    },
];

const getSortButtonClassname = (column, col, direction) => {
    if (col === column.accessor) {
        switch (direction) {
            case ORDER_BY_DESC:
                return 'sort-desc';
            case ORDER_BY_ASC:
                return 'sort-asc';
            default:
                return 'sortable';
        }
    } else {
        return 'sortable';
    }
};

const renderHeaders = ({ page = 1, col, direction }) => {
    return columns.map(column => {
        const th = cEl('div');
        th.classList.add('th');
        th.style.flex = `1 0 ${column.width}px`;
        if (typeof column.Header === 'function') {
            th.append(column.Header());
        } else {
            th.append(column.Header);
        }

        if (column.sortable) {
            const button = cEl('button');
            button.classList.add('sort-button', getSortButtonClassname(column, col, direction));
            button.addEventListener('click', e => {
                const { sort, page: currPage, ...hashParam } = getSubmissionsQueryParam();
                const changeDirection = !direction || direction === ORDER_BY_ASC ? ORDER_BY_DESC : ORDER_BY_ASC;
                navigateTo(
                    getFullPath({
                        col: column.accessor,
                        direction: changeDirection,
                        ...hashParam,
                        page,
                    }),
                );
            });
            th.append(button);
        }

        return th;
    });
};

const renderRow = (rowData, meta) => {
    return columns.map(column => {
        const th = cEl('div');
        th.classList.add('td');
        th.style.flex = `1 0 ${column.width}px`;
        if (typeof column.Cell === 'function') {
            const Cell = column.Cell(rowData[column.accessor], rowData, meta);
            if (Cell) {
                th.append(Cell);
            }
        } else {
            const data = rowData[column.accessor];
            if (data !== null && data !== undefined) {
                const tableCell = cEl('span');
                tableCell.classList.add('table-cell', ...(column.classNames || []));
                tableCell.innerHTML = data;
                tableCell.title = data;
                th.append(tableCell);
            }
        }
        return th;
    });
};

function Table({ totalPage, totalCount, page, rows = [], sort = [] }) {
    const { property: col, direction } = sort[0] || {};
    const tableContainer = cEl('div');
    tableContainer.classList.add('table-container');
    const thead = cEl('div');
    thead.classList.add('table-head');
    const tr = cEl('div');
    tr.classList.add('table-row');
    tr.append(...renderHeaders({ page, col, direction }));
    thead.append(tr);

    const tbody = cEl('div');
    tbody.classList.add('table-body');
    const data = rows.concat(Array(PAGE_SIZE - rows.length).fill({}));
    const trs = data.map(submission => {
        const tr = cEl('div');
        tr.classList.add('table-row');
        if (submission.submissionNum) {
            tr.classList.add('valid-row');
        }
        tr.append(...renderRow(submission, { totalCount }));
        tr.addEventListener('click', () => {
            if (submission.submissionNum) {
                navigateTo(
                    `${PATH_ADMIN_SUBMISSION_DETAIL.replace(PATH_VARIABLE_SUBMISSION_NUM, '')}${submission.submissionNum}`,
                );
            }
        });
        return tr;
    });
    tbody.append(...trs);

    tableContainer.append(thead, tbody);

    const tableFooter = cEl('div');
    tableFooter.classList.add('table-footer');
    if (totalPage) {
        tableFooter.append(PageNav({ totalPage, page, col, direction }));
    }

    tableContainer.append(tableFooter);

    return tableContainer;
}

export const getFullPath = param => {
    const validParam = { ...param };
    for (const [key, value] of Object.entries(validParam)) {
        if (value === undefined) {
            delete validParam[key];
        }
    }
    return `${PATH_ADMIN_SUBMISSIONS}?${new URLSearchParams(validParam).toString()}`;
};

function PageNav({ totalPage, page, col, direction }) {
    const { sort, page: currPage, ...hashParam } = getSubmissionsQueryParam();
    const param = col && direction ? { col, direction, ...hashParam } : col ? { col, ...hashParam } : { ...hashParam };
    const pageContainer = cEl('div');
    pageContainer.classList.add('page-container');

    const pageListNum = Math.floor((page - 1) / PAGE_LIST_SIZE);
    const maxPageListNum = Math.floor((totalPage - 1) / PAGE_LIST_SIZE);

    const pageListRange = Array(Math.max(Math.min(totalPage - PAGE_LIST_SIZE * pageListNum, PAGE_LIST_SIZE), 0))
        .fill(0)
        .map((v, index) => {
            const pageNum = pageListNum * PAGE_LIST_SIZE + 1 + index;
            const button = cEl('button');
            button.classList.add('page-num', pageNum === page ? 'active' : 'normal');
            button.innerHTML = pageNum;
            button.addEventListener('click', () => {
                navigateTo(
                    getFullPath({
                        ...param,
                        page: pageNum,
                    }),
                );
            });
            return button;
        });

    const hasPrevPage = pageListNum !== 0;
    const hasNextPage = maxPageListNum > pageListNum;

    pageContainer.append(...pageListRange);
    if (hasPrevPage) {
        const button = cEl('button');
        button.classList.add('page-button');
        const img = cEl('img');
        img.src = pageLeftArrow;
        button.append(img);
        button.addEventListener('click', () => {
            navigateTo(
                getFullPath({
                    ...param,
                    page: (pageListNum - 1) * PAGE_LIST_SIZE + 1,
                }),
            );
        });

        pageContainer.prepend(button);
    }
    if (hasNextPage) {
        const button = cEl('button');
        button.classList.add('page-button');
        const img = cEl('img');
        img.src = pageRightArrow;
        button.append(img);
        button.addEventListener('click', () => {
            navigateTo(
                getFullPath({
                    ...param,
                    page: (pageListNum + 1) * PAGE_LIST_SIZE + 1,
                }),
            );
        });
        pageContainer.append(button);
    }

    return pageContainer;
}

function formatTimestamp(timestamp) {
    const date = new Date(timestamp * 1000);

    const pad = n => n.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // 0부터 시작하므로 +1
    const day = pad(date.getDate());

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;
}

export default Table;
